module.exports = __webpack_public_path__ + "media/images/sme-bg-37b87b25299afc10461508b92d00d021.jpg";